import type { ChatMessage, ChatSuggestionsPayload } from '@/types';

/** Canonical suggestions cursor: `{threadId}:{serverMessageId}:{turnRunId}` */
export function buildSuggestionsCursorKey(
  threadId: string,
  serverMessageId: string,
  turnRunId?: string | null,
): string {
  return [threadId, serverMessageId, turnRunId ?? ''].join(':');
}

export function cursorKeyFromPayload(payload?: ChatSuggestionsPayload | null): string | null {
  const cursor = payload?.cursor;
  if (!cursor?.thread_id) return null;
  return buildSuggestionsCursorKey(
    cursor.thread_id,
    cursor.after_assistant_message_id ?? '',
    cursor.turn_run_id ?? '',
  );
}

/** Django message pk when persisted; falls back to `id` for history-loaded rows. */
export function resolveServerMessageId(message: ChatMessage): string | undefined {
  if (message.isUser || message.isDelta) return undefined;
  const serverId = 'serverMessageId' in message ? message.serverMessageId : undefined;
  if (serverId) return String(serverId);
  if (message.id && !message.id.startsWith('text_')) return message.id;
  return undefined;
}
